<div id="wrap" [@wrapAnimation] (click)="screenClick()" *ngIf="data && userType">

  <div id="questionCard" [@questionCardAnimation]="qCardShow ? 'showQCard':'hideQCard'"
       [style.display]="showId==1?'block':''">
    <div class="questionTitle fontSize16">
      {{currentQuestionTitle}}
    </div>
    <div *ngIf="currentQuestion.type==1">
      <div class="optionItem fontSize14" *ngFor="let option of currentQuestion.options;let i=index"
           (click)="onOptionClick($event,i)"
           [ngClass]="{'unselectedOptionItem':optionSelectedIndex!=i,'selectedOptionItem':optionSelectedIndex==i}">
        {{option}}
      </div>
    </div>

    <div *ngIf="currentQuestion.type==2">
      <div class="sortOptionItem" *ngFor="let option of currentQuestion.options;let i=index">
        <div class="sortOptionItemContent fontSize14">
          <span class="textVerticalCenter">{{option}}</span>
        </div>
        <div class="arrowDown"
             *ngIf="i!=currentQuestion.options.length-1"
             (click)="arrowDownClick(i)"></div>
        <div class="arrowUp"
             *ngIf="i!=0"
             [style.marginLeft]="i==currentQuestion.options.length-1?'0.33rem':'0.2rem'"
             (click)="arrowUpClick(i)"></div>
      </div>
    </div>

    <div class="questionBtn fontSize16"
         [ngClass]="{'inactiveQuestionBtn':optionSelectedIndex<0,'activeQuestionBtn':optionSelectedIndex>=0}"
         (click)="cardOnSubmit1 ? null : onQuestionBtnClick($event)" *ngIf="currentQuestion.type==1">
      <span *ngIf="step != 406 && step != 701 && step != 407 && step != 702">继续</span>
      <span *ngIf="step == 406 || step == 407">了解, 继续</span>
      <span *ngIf="step == 701 || step == 702">查看反馈</span>
    </div>
    <div class="sortQuestionBtn fontSize16" (click)="cardOnSubmit2 ? null : onSortQuestionBtnClick($event)"
         *ngIf="currentQuestion.type==2">
      确认，继续
    </div>

  </div>


  <img src="{{assetsRoute}}/picture/casepracticepando/teacher3.png" alt="" id="teacherPic">

  <img src="{{assetsRoute}}/picture/casepracticepando/informationtable.png"
       [@infoTableAnimation]="infoTableShow ? 'showInfoTable':'hideInfoTable'" alt="" id="informationTable">

  <div id="teacherAnalysis" [@teacherAnimation]="teacherShow ? 'showTeacher':'hideTeacher'" class="fontSize16">
    <div id="teacherAnalysisText" [innerHtml]="analysis"></div>
    <div id="teacher-arrow"></div>
  </div>

  <div id="instructionBox" [@instructionAnimation]="instructionShow ? 'showInstruction' : 'hideInstruction'"
       class="fontSize16" [innerHtml]="instruction" [style.display]="showId==2?'block':''">
  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/decision.png"
       [@decisionAnimation]="decisionShow ? 'showDecision':'hideDecision'" alt="" id="decision">

  <img src="{{assetsRoute}}/picture/casepracticepando/wln4.png" alt=""
       [@wlnPhoneAnimation]="wlnPhoneShow ? 'showWlnPhone':'hideWlnPhone'" id="wlnTelephone"
       [style.display]="showId==3?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/fkk5.png" alt=""
       [@fkkPhoneAnimation]="fkkPhoneShow ? 'showFkkPhone':'hideFkkPhone'" id="fkkTelephone">

  <div id="dialogueBox1" [@dialogue1Animation]="diag1Show ? 'showDiag1': 'hideDiag1'" class="fontSize16 lineHeight24"
       [style.display]="showId==3?'block':''">
    {{currentShortConversation}}
    <div id="dialogueBox1-arrow"></div>
  </div>

  <div id="dialogueBox2" [@dialogue2Animation]="diag2Show ? 'showDiag2': 'hideDiag2'" class="fontSize16 lineHeight24">
    <div id="meBox">
      我
    </div>
    <span>{{currentShortConversation}}</span>
    <div id="dialogueBox2-arrow"></div>
  </div>

  <div id="dialogueBox3" class="fontSize16 lineHeight24" [style.display]="showId==4?'block':''">
    <div id="meBox2">
      我
    </div>
    <span>{{currentShortConversation}}</span>
  </div>

  <div id="dialogueBox4" class="fontSize16 lineHeight24">
    <div id="qfBox">
      秦飞
    </div>
    <span>{{currentShortConversation}}</span>
  </div>

  <div id="optionsWrap2">
    <div id="optionTip2" class="fontSize16 optionTips">
      长按按钮进行选择
    </div>

    <div *ngIf="!type">
      <div class="optionItem2 fontSize16"
           *ngFor="let option of currentQuestion.options;let i=index"
           (touchstart)="onOptionMouseDown(i, $event)" (touchend)="onOptionMouseUp($event)">
        {{option}}
        <div class="loading">
          <div class='dotting' id='dotting1'></div>
          <div class='dotting' id='dotting2'></div>
          <div class='dotting' id='dotting3'></div>
        </div>
        <div class="pressing">
          <div class="pressingOption">{{option}}</div>
        </div>
      </div>
    </div>

    <div *ngIf="type">
      <div class="optionItem2 fontSize16"
           *ngFor="let option of currentQuestion.options;let i=index"
            (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)">
        {{option}}
        <div class="loading">
          <div class='dotting' id='dotting1'></div>
          <div class='dotting' id='dotting2'></div>
          <div class='dotting' id='dotting3'></div>
        </div>
        <div class="pressing">
          <div class="pressingOption">{{option}}</div>
        </div>
      </div>
    </div>

  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/fkk2.png" alt="" id="fkk2">

  <div id="fkkContent" [@fkkContentAnimation]="fkkContentShow ? 'showFkkContent' : 'hideFkkContent'" class="fontSize16">
    {{currentShortConversation}}
  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/tasktable.png"
       [@taskTableAnimation]="taskTableShow ? 'showTaskTable': 'hideTaskTable'" alt="" id="taskTable">
  <img src="{{assetsRoute}}/picture/casepracticepando/urgent.png"
       [@urgentAnimation]="urgentShow ? 'showUrgent':'hideUrgent'" alt="" id="urgent">
  <img src="{{assetsRoute}}/picture/casepracticepando/urgent.png"
       [@urgent2Animation]="urgent2Show ? 'showUrgent2':'hideUrgent2'" alt="" id="urgent2">
  <img src="{{assetsRoute}}/picture/casepracticepando/boo.png" alt="" id="boo">
  <div id="urgentText" class="fontSize27 lineHeight32">紧急事件</div>
  <img src="{{assetsRoute}}/picture/casepracticepando/gl1.png" alt="" id="gl" [style.display]="showId==4?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/wln1.png" alt="" id="wln">
  <img src="{{assetsRoute}}/picture/casepracticepando/fkk1.png" alt="" id="fkk" [style.display]="showId==4?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/qf.png" alt="" id="qf" [style.display]="showId==4?'block':''">

  <div id="qf2">
  </div>
  <div id="customerWrap" [@customAnimation]="customShow ? 'showCustom': 'hideCustom'">
    <div class="asideTitle fontSize18 lineHeight32">
      客<br/>户<br/>信<br/>息
    </div>
    <div class="customCard" id="customCard1">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">A<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 600<br/>
                    拜访时间(分) 60<br/>
                    所需年资(年) >5
                </span>
      </div>
    </div>
    <div class="customCard" id="customCard2">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">B<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 250<br/>
                    拜访时间(分) 30<br/>
                    所需年资(年) 1-5
                </span>
      </div>
    </div>
    <div class="customCard" id="customCard3">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">C<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 100<br/>
                    拜访时间(分) 15<br/>
                    所需年资(年) 不限
                </span>
      </div>
    </div>
  </div>

  <div id="siteWrap" [@siteAnimation]="siteShow ? 'showSite':'hideSite'">
    <div class="asideTitle fontSize18 lineHeight32">
      场<br/>地<br/>信<br/>息
    </div>
    <div id="asideSiteTitle" class="fontSize16 lineHeight32">
      15 Min
    </div>
    <div id="sitePath"></div>
    <div id="urgentText" class="fontSize27 lineHeight32">紧急事件</div>
    <div class="siteCard" id="siteCard1">
      <div class="siteCardLeft fontSize14">
        <span class="textVerticalCenter">分<br/>会<br/>场</span>
      </div>
      <div class="siteCardRight fontSize16 lineHeight27">
                <span class="textVerticalCenter">
                    A级客户： 1个<br/>
                    C级客户： 18个
                </span>
      </div>
    </div>
    <div class="siteCard" id="siteCard2">
      <div class="siteCardLeft fontSize14">
        <span class="textVerticalCenter">主<br/>会<br/>场</span>
      </div>
      <div class="siteCardRight fontSize16 lineHeight27">
                <span class="textVerticalCenter">
                    A级客户： 6个<br/>
                    B级客户： 9个
                </span>
      </div>
    </div>
    <div class="siteInformationBox fontSize16">
            <span class="textVerticalCenter">
                这次展览会有两个会场。分别位于山上和山下，从主会场到分会场需要15分钟，场地入口在山下的主会场。
            </span>
    </div>
  </div>

  <div id="teamWrap" [@teamAnimation]="teamShow ? 'showTeam':'hideTeam'">
    <div class="asideTitle fontSize18 lineHeight32">
      团<br/>队<br/>信<br/>息
    </div>
    <div class="teamItem" id="teamItem1">
      <div class="teamTextBox fontSize14">
        高朗：3个月
      </div>
    </div>

    <div class="teamItem" id="teamItem2">
      <div class="teamTextBox fontSize14">
        方科科：2年
      </div>
    </div>

    <div class="teamItem" id="teamItem3">
      <div class="teamTextBox fontSize14">
        秦飞：8年
      </div>
    </div>

    <div class="teamItem" id="teamItem4">
      <div class="teamTextBox fontSize14">
        我：10年
      </div>
    </div>
  </div>

  <div id="calculationWrap" [style.display]="showId==5?'block':''">
    <div id="customerInfoBtn" class="fontSize16" (click)="onCustomerInfoBtn($event)">
            <span class="textVerticalCenter">
                客户<br/>信息
            </span>
    </div>

    <div id="calculationTopPic">

    </div>

    <img src="{{assetsRoute}}/picture/casepracticepando/path2.png" alt="" class="path2">

    <div id="calculationMainWrap">
      <div id="calculationMainHead">
        <div id="calculationMainHead1" class="fontSize14">
          人选
        </div>

        <div class="calculationText1 fontSize14">
          点击方框增加数量
        </div>

        <div class="calculationText2 fontSize14">
          A: 60min B:30min C:15min
        </div>

        <div id="calculationMainHead2" class="fontSize14">
          主会场 A:{{customerArray[0]}} B:{{customerArray[1]}}
        </div>

        <div id="calculationMainHead3" class="fontSize14">
          分会场 A:{{customerArray[2]}} C:{{customerArray[3]}}
        </div>
      </div>
      <div class="calculationMainItem" *ngFor="let item of calculationMatrix;let i = index"
           [style.visibility]="!meSelected&&i==3?'hidden':''">
        <div class="calculationMainRole calculationMainRole{{i}}">
          <div class="calculationMainRoleText fontSize14">
            {{item.experience}}
          </div>
        </div>
        <div class="calculationMainItem{{j}} calculationMainItemSquare"
             *ngFor="let subItem of item.numberArray;let j = index" (click)="onSquareClick($event,i,j)"
             [style.border]="subItem>0?'0.04rem #349fd6 solid':''"
        >
          <div class="minusBtn fontSize16" (click)="onMinusBtnClick($event,i,j)" *ngIf="subItem>0">
            -
          </div>
          <div class="calculationMainItemSquareNumber fontSize27 textVerticalCenter" *ngIf="subItem>0">
            {{subItem}}
          </div>
        </div>
      </div>

      <div id="calculationSubmitBtn" class="fontSize16"
           [ngClass]="{'inactiveQuestionBtn':!isActiveCalculationBtn,'activeQuestionBtn':isActiveCalculationBtn}"
           (click)="cardOnSubmit3 ? null : submitCalculation($event)">
        提交方案
      </div>

    </div>
  </div>

  <div class="fontSize18" id="reportBtn" (click)="linkToReport()" [style.display]="reportBtnShow?'block':''">
    生成报告
  </div>

  <div id="shade"></div>

  <div id="customerInfoWrap">
    <div id="customerTitle" class="fontSize16">
      客户信息
    </div>
    <div class="customCard customCardInner" id="customCardInner1">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">A<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 600<br/>
                    拜访时间(分) 60<br/>
                    所需年资(年) >5
                </span>
      </div>
    </div>

    <div class="customCard customCardInner" id="customCardInner2">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">B<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 250<br/>
                    拜访时间(分) 30<br/>
                    所需年资(年) 1-5
                </span>
      </div>
    </div>

    <div class="customCard customCardInner" id="customCardInner3">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">C<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 100<br/>
                    拜访时间(分) 15<br/>
                    所需年资(年) 不限
                </span>
      </div>
    </div>
  </div>

  <!--<div id="reviewBox">-->
    <!--&lt;!&ndash;<div id="reviewBoxTitle" class="fontSize18 lineHeight24" >&ndash;&gt;-->
    <!--&lt;!&ndash;场景回顾&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--<p class="excellentDemonstrationTitle flowerBorderBottom">场景回顾</p>-->

    <!--<div class="reviewItem" *ngFor="let item of eventHistory;let i=index">-->

      <!--&lt;!&ndash;<p><span>王立娜</span><span>老大，客户已经到了，但有个情况我搞不定，想问问该怎么办。</span></p>&ndash;&gt;-->
      <!--&lt;!&ndash;<p><span class="fontBlue">我</span><span>出了什么事？</span></p>&ndash;&gt;-->
      <!--&lt;!&ndash;<p><span>王立娜</span><span>客户对新产品也很有兴趣，想了解技术方面的细节，但技术方面我不擅长，方科科也不在…</span></p>&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="fontBlue2">「最佳选择」</p>&ndash;&gt;-->
      <!--&lt;!&ndash;<p>立娜，你还记得研发部的方信愿意支持27号的市场活动么？你可以和他沟通下目前的情况，看是否可以得到他的协助。</p></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="sectionBox sectionBox4">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="sectionIcon2">剧情4</div>&ndash;&gt;-->
        <!--&lt;!&ndash;<p>参展客户临时有了变动，但因为整个团队都在飞机上，未能及时收到主办方的信息。到了后，我才得知一共只有4小时来拜访客户，那么第一步该怎么做呢？</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="fontBlue2">「最佳选择」</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p>想办法取得客户清单和掌握会场情况。</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>&ndash;&gt;-->
          <!--&lt;!&ndash;<p>行动之前，要扎好马步：建立信息基础。只有先收集会场目前最新的状况，才能制定更高效的拜访计划。</p></div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="sectionBox sectionBox5">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="sectionIcon2">剧情5</div>&ndash;&gt;-->
        <!--&lt;!&ndash;<p>在给其他伙伴安排任务前，先确定自己的任务吧。</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="fontBlue2">「最佳选择」</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p>亲自参与拜访客户</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>&ndash;&gt;-->
          <!--&lt;!&ndash;<p>还是回到参加这次展会的目标，要拜访尽可能多的客户，这样才更有利于实现今年我们部门的目标——拓展北美市场。所以这里“我”作为有10年经验的客户经理，是不是也应该与大家并肩作战，参与到拜访客户的行动中呢？</p>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="sectionBox sectionBox6">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="sectionIcon">剧情6</div>&ndash;&gt;-->
        <!--&lt;!&ndash;<p>拜访任务分配</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="fontBlue2">「最佳选择」</p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="smLineHeight"><span>秦飞</span><span>山下A级客户4个</span></p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="smLineHeight"><span>我</span><span>山下A级客户2个，B级客户1个；山上A级客户1个，C级客户1个</span></p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="smLineHeight"><span>方科科</span><span>山下B级客户8个</span></p>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="smLineHeight"><span>高朗</span><span>山上C级客户15个</span></p>&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>&ndash;&gt;-->
          <!--&lt;!&ndash;<p>&ndash;&gt;-->
            <!--&lt;!&ndash;这里的安排要考虑到4点：第一、每个人年资不一样，“我”和秦飞可以拜访所有类型客户，方科科不能拜访A级客户，高朗只能拜访C级客户。不要越级拜访，或者浪费资源，比如让秦飞去拜访B和C级客户。第二、按照客单价，应该优先安排拜访A级客户，然后才是B级客户，最后再考虑C级客户。第三、要注意时间，每个人只有240分钟，最好都能用上。如果要去山上，还要考虑留15分钟在路上。第四、秦飞身体不适，而“我”和他都可以拜访所有类型客户。最好就是让他在山下，不用爬山劳顿。所以综上所述，建议安排如最佳选择。</p>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="reviewDialogInline"  *ngIf="item.type==3">-->
        <!--<div class="reviewRole fontSize14 lineHeight24 reviewRole_{{item.type}}" *ngIf="item.type==3" [innerHtml]="item.role"></div>-->
        <!--<div class="reviewComment fontSize14 lineHeight21 reviewComment_{{item.type}}" *ngIf="item.type==3" [innerHtml]="item.comment"> </div>-->
      <!--</div>-->


      <!--<div class="bg-lightBlue" *ngIf="item.type==5">-->
        <!--<div class="excellentDemonstrationTitle reviewRole fontSize14 lineHeight24 reviewRole_{{item.type}}" [innerHtml]="item.role" *ngIf="item.type==5"></div>-->
        <!--<div class="reviewComment fontSize14 lineHeight21 reviewComment_{{item.type}}" [innerHtml]="item.comment" *ngIf="item.type==1||item.type==2||item.type==5"></div>-->
      <!--</div>-->
      <!--<div class="reviewAnswerBox fontSize14 lineHeight24" *ngIf="item.type==4">-->
        <!--<div class="reviewAnswerHead" [innerHtml]="item.role"></div>-->
        <!--<div class="reviewAnswerMain reviewAnswerMain_1" [innerHtml]="item.comment"></div>-->
      <!--</div>-->
      <!--<div class="reviewAnswerBox fontSize14 lineHeight24" *ngIf="item.type==9" (click)="reviewTableClick($event,i)">-->
        <!--<div class="reviewAnswerHead">-->
          <!--{{item.role}}-->
          <!--<i class="fa fa-caret-up fa-lg discussionBgIcon" *ngIf="item.mode==1"></i>-->
          <!--<i class="fa fa-caret-down fa-lg discussionBgIcon" *ngIf="item.mode==0"></i>-->
        <!--</div>-->
        <!--<div class="reviewAnswerMain reviewAnswerMain_{{item.mode}}" [innerHtml]="item.comment"></div>-->
      <!--</div>-->
    <!--</div>-->
  <!--</div>-->

  <div id="closeBtn" (click)="closeTip($event)"></div>

  <img src="{{assetsRoute}}/picture/casepracticepando/close.png" alt="" id="customerInfoCloseBtn"
       (click)="onCustomerInfoCloseBtnClick($event)" class="imgAble">
</div>

<div id="shade2" ></div>

<div id="tip2" class="fontSize16">
  <div class="tip2Txt">
    想要体验更多内容，欢迎前来注册
  </div>
  <div class="orangeTxt">「限时获取企业体验机会&关键行动分析报告」</div>
  <img src="{{assetsRoute}}/picture/learningpath/testUserLayer2.png" alt="">

  <div id="tipBtn2"  (click)="try()">前往注册</div>
  <div id="backLearningMap"  (click)="returnList()">返回列表</div>

</div>

<div id="wrap" [@wrapAnimation] (click)="screenClick()" *ngIf="data && !userType">
  <div id="reviewBtn" class="fontSize16" [style.display]="showId==5?'none':''" (click)="reviewConversation($event)">
    场景回顾
  </div>

  <div id="questionCard" [@questionCardAnimation]="qCardShow ? 'showQCard':'hideQCard'"
       [style.display]="showId==1?'block':''">
    <div class="questionTitle fontSize16">
      {{currentQuestionTitle}}
    </div>
    <div *ngIf="currentQuestion.type==1">
      <div class="optionItem fontSize14" *ngFor="let option of currentQuestion.options;let i=index"
           (click)="onOptionClick($event,i)"
           [ngClass]="{'unselectedOptionItem':optionSelectedIndex!=i,'selectedOptionItem':optionSelectedIndex==i}">
        {{option}}
      </div>
    </div>

    <div *ngIf="currentQuestion.type==2">
      <div class="sortOptionItem" *ngFor="let option of currentQuestion.options;let i=index">
        <div class="sortOptionItemContent fontSize14">
          <span class="textVerticalCenter">{{option}}</span>
        </div>
        <div class="arrowDown"
             *ngIf="i!=currentQuestion.options.length-1"
             (click)="arrowDownClick(i)"></div>
        <div class="arrowUp"
             *ngIf="i!=0"
             [style.marginLeft]="i==currentQuestion.options.length-1?'0.33rem':'0.2rem'"
             (click)="arrowUpClick(i)"></div>
      </div>
    </div>

    <div class="questionBtn fontSize16"
         [ngClass]="{'inactiveQuestionBtn':optionSelectedIndex<0,'activeQuestionBtn':optionSelectedIndex>=0}"
         (click)="cardOnSubmit1 ? null : onQuestionBtnClick($event)" *ngIf="currentQuestion.type==1">
      <span *ngIf="step != 406 && step != 701 && step != 407 && step != 702">继续</span>
      <span *ngIf="step == 406 || step == 407">了解, 继续</span>
      <span *ngIf="step == 701 || step == 702">查看反馈</span>
    </div>
    <div class="sortQuestionBtn fontSize16" (click)="cardOnSubmit2 ? null : onSortQuestionBtnClick($event)"
         *ngIf="currentQuestion.type==2">
      确认，继续
    </div>

  </div>


  <img src="{{assetsRoute}}/picture/casepracticepando/teacher3.png" alt="" id="teacherPic">

  <img src="{{assetsRoute}}/picture/casepracticepando/informationtable.png"
       [@infoTableAnimation]="infoTableShow ? 'showInfoTable':'hideInfoTable'" alt="" id="informationTable">

  <div id="teacherAnalysis" [@teacherAnimation]="teacherShow ? 'showTeacher':'hideTeacher'" class="fontSize16">
    <div id="teacherAnalysisText" [innerHtml]="analysis"></div>
    <div id="teacher-arrow"></div>
  </div>

  <div id="instructionBox" [@instructionAnimation]="instructionShow ? 'showInstruction' : 'hideInstruction'"
       class="fontSize16" [innerHtml]="instruction" [style.display]="showId==2?'block':''">
  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/decision.png"
       [@decisionAnimation]="decisionShow ? 'showDecision':'hideDecision'" alt="" id="decision">

  <img src="{{assetsRoute}}/picture/casepracticepando/wln4.png" alt=""
       [@wlnPhoneAnimation]="wlnPhoneShow ? 'showWlnPhone':'hideWlnPhone'" id="wlnTelephone"
       [style.display]="showId==3?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/fkk5.png" alt=""
       [@fkkPhoneAnimation]="fkkPhoneShow ? 'showFkkPhone':'hideFkkPhone'" id="fkkTelephone">

  <div id="dialogueBox1" [@dialogue1Animation]="diag1Show ? 'showDiag1': 'hideDiag1'" class="fontSize16 lineHeight24"
       [style.display]="showId==3?'block':''">
    {{currentShortConversation}}
    <div id="dialogueBox1-arrow"></div>
  </div>

  <div id="dialogueBox2" [@dialogue2Animation]="diag2Show ? 'showDiag2': 'hideDiag2'" class="fontSize16 lineHeight24">
    <div id="meBox">
      我
    </div>
    <span>{{currentShortConversation}}</span>
    <div id="dialogueBox2-arrow"></div>
  </div>

  <div id="dialogueBox3" class="fontSize16 lineHeight24" [style.display]="showId==4?'block':''">
    <div id="meBox2">
      我
    </div>
    <span>{{currentShortConversation}}</span>
  </div>

  <div id="dialogueBox4" class="fontSize16 lineHeight24">
    <div id="qfBox">
      秦飞
    </div>
    <span>{{currentShortConversation}}</span>
  </div>

  <div id="optionsWrap2">
    <div id="optionTip2" class="fontSize16 optionTips">
      长按按钮进行选择
    </div>

    <div *ngIf="!type">
      <div class="optionItem2 fontSize16"
           *ngFor="let option of currentQuestion.options;let i=index"
           (touchstart)="onOptionMouseDown(i, $event)" (touchend)="onOptionMouseUp($event)">
        {{option}}
        <div class="loading">
          <div class='dotting' id='dotting1'></div>
          <div class='dotting' id='dotting2'></div>
          <div class='dotting' id='dotting3'></div>
        </div>
        <div class="pressing">
          <div class="pressingOption">{{option}}</div>
        </div>
      </div>
    </div>

    <div *ngIf="type">
      <div class="optionItem2 fontSize16"
           *ngFor="let option of currentQuestion.options;let i=index"
           (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)">
        {{option}}
        <div class="loading">
          <div class='dotting' id='dotting1'></div>
          <div class='dotting' id='dotting2'></div>
          <div class='dotting' id='dotting3'></div>
        </div>
        <div class="pressing">
          <div class="pressingOption">{{option}}</div>
        </div>
      </div>
    </div>

  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/fkk2.png" alt="" id="fkk2">

  <div id="fkkContent" [@fkkContentAnimation]="fkkContentShow ? 'showFkkContent' : 'hideFkkContent'" class="fontSize16">
    {{currentShortConversation}}
  </div>

  <img src="{{assetsRoute}}/picture/casepracticepando/tasktable.png"
       [@taskTableAnimation]="taskTableShow ? 'showTaskTable': 'hideTaskTable'" alt="" id="taskTable">
  <img src="{{assetsRoute}}/picture/casepracticepando/urgent.png"
       [@urgentAnimation]="urgentShow ? 'showUrgent':'hideUrgent'" alt="" id="urgent">
  <img src="{{assetsRoute}}/picture/casepracticepando/urgent.png"
       [@urgent2Animation]="urgent2Show ? 'showUrgent2':'hideUrgent2'" alt="" id="urgent2">
  <img src="{{assetsRoute}}/picture/casepracticepando/boo.png" alt="" id="boo">
  <div id="urgentText" class="fontSize27 lineHeight32">紧急事件</div>
  <img src="{{assetsRoute}}/picture/casepracticepando/gl1.png" alt="" id="gl" [style.display]="showId==4?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/wln1.png" alt="" id="wln">
  <img src="{{assetsRoute}}/picture/casepracticepando/fkk1.png" alt="" id="fkk" [style.display]="showId==4?'block':''">
  <img src="{{assetsRoute}}/picture/casepracticepando/qf.png" alt="" id="qf" [style.display]="showId==4?'block':''">

  <div id="qf2">
  </div>
  <div id="customerWrap" [@customAnimation]="customShow ? 'showCustom': 'hideCustom'">
    <div class="asideTitle fontSize18 lineHeight32">
      客<br/>户<br/>信<br/>息
    </div>
    <div class="customCard" id="customCard1">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">A<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 600<br/>
                    拜访时间(分) 60<br/>
                    所需年资(年) >5
                </span>
      </div>
    </div>
    <div class="customCard" id="customCard2">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">B<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 250<br/>
                    拜访时间(分) 30<br/>
                    所需年资(年) 1-5
                </span>
      </div>
    </div>
    <div class="customCard" id="customCard3">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">C<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 100<br/>
                    拜访时间(分) 15<br/>
                    所需年资(年) 不限
                </span>
      </div>
    </div>
  </div>

  <div id="siteWrap" [@siteAnimation]="siteShow ? 'showSite':'hideSite'">
    <div class="asideTitle fontSize18 lineHeight32">
      场<br/>地<br/>信<br/>息
    </div>
    <div id="asideSiteTitle" class="fontSize16 lineHeight32">
      15 Min
    </div>
    <div id="sitePath"></div>
    <div id="urgentText" class="fontSize27 lineHeight32">紧急事件</div>
    <div class="siteCard" id="siteCard1">
      <div class="siteCardLeft fontSize14">
        <span class="textVerticalCenter">分<br/>会<br/>场</span>
      </div>
      <div class="siteCardRight fontSize16 lineHeight27">
                <span class="textVerticalCenter">
                    A级客户： 1个<br/>
                    C级客户： 18个
                </span>
      </div>
    </div>
    <div class="siteCard" id="siteCard2">
      <div class="siteCardLeft fontSize14">
        <span class="textVerticalCenter">主<br/>会<br/>场</span>
      </div>
      <div class="siteCardRight fontSize16 lineHeight27">
                <span class="textVerticalCenter">
                    A级客户： 6个<br/>
                    B级客户： 9个
                </span>
      </div>
    </div>
    <div class="siteInformationBox fontSize16">
            <span class="textVerticalCenter">
                这次展览会有两个会场。分别位于山上和山下，从主会场到分会场需要15分钟，场地入口在山下的主会场。
            </span>
    </div>
  </div>

  <div id="teamWrap" [@teamAnimation]="teamShow ? 'showTeam':'hideTeam'">
    <div class="asideTitle fontSize18 lineHeight32">
      团<br/>队<br/>信<br/>息
    </div>
    <div class="teamItem" id="teamItem1">
      <div class="teamTextBox fontSize14">
        高朗：3个月
      </div>
    </div>

    <div class="teamItem" id="teamItem2">
      <div class="teamTextBox fontSize14">
        方科科：2年
      </div>
    </div>

    <div class="teamItem" id="teamItem3">
      <div class="teamTextBox fontSize14">
        秦飞：8年
      </div>
    </div>

    <div class="teamItem" id="teamItem4">
      <div class="teamTextBox fontSize14">
        我：10年
      </div>
    </div>
  </div>

  <div id="calculationWrap" [style.display]="showId==5?'block':''">
    <div id="customerInfoBtn" class="fontSize16" (click)="onCustomerInfoBtn($event)">
            <span class="textVerticalCenter">
                客户<br/>信息
            </span>
    </div>

    <div id="calculationTopPic">

    </div>

    <img src="{{assetsRoute}}/picture/casepracticepando/path2.png" alt="" class="path2">

    <div id="calculationMainWrap">
      <div id="calculationMainHead">
        <div id="calculationMainHead1" class="fontSize14">
          人选
        </div>

        <div class="calculationText1 fontSize14">
          点击方框增加数量
        </div>

        <div class="calculationText2 fontSize14">
          A: 60min B:30min C:15min
        </div>

        <div id="calculationMainHead2" class="fontSize14">
          主会场 A:{{customerArray[0]}} B:{{customerArray[1]}}
        </div>

        <div id="calculationMainHead3" class="fontSize14">
          分会场 A:{{customerArray[2]}} C:{{customerArray[3]}}
        </div>
      </div>
      <div class="calculationMainItem" *ngFor="let item of calculationMatrix;let i = index"
           [style.visibility]="!meSelected&&i==3?'hidden':''">
        <div class="calculationMainRole calculationMainRole{{i}}">
          <div class="calculationMainRoleText fontSize14">
            {{item.experience}}
          </div>
        </div>
        <div class="calculationMainItem{{j}} calculationMainItemSquare"
             *ngFor="let subItem of item.numberArray;let j = index" (click)="onSquareClick($event,i,j)"
             [style.border]="subItem>0?'0.04rem #349fd6 solid':''"
        >
          <div class="minusBtn fontSize16" (click)="onMinusBtnClick($event,i,j)" *ngIf="subItem>0">
            -
          </div>
          <div class="calculationMainItemSquareNumber fontSize27 textVerticalCenter" *ngIf="subItem>0">
            {{subItem}}
          </div>
        </div>
      </div>

      <div id="calculationSubmitBtn" class="fontSize16"
           [ngClass]="{'inactiveQuestionBtn':!isActiveCalculationBtn,'activeQuestionBtn':isActiveCalculationBtn}"
           (click)="cardOnSubmit3 ? null : submitCalculation($event)">
        提交方案
      </div>

    </div>
  </div>

  <div class="fontSize18" id="reportBtn" (click)="linkToReport()" [style.display]="reportBtnShow?'block':''">
    生成报告
  </div>

  <div id="shade"></div>

  <div id="customerInfoWrap">
    <div id="customerTitle" class="fontSize16">
      客户信息
    </div>
    <div class="customCard customCardInner" id="customCardInner1">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">A<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 600<br/>
                    拜访时间(分) 60<br/>
                    所需年资(年) >5
                </span>
      </div>
    </div>

    <div class="customCard customCardInner" id="customCardInner2">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">B<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 250<br/>
                    拜访时间(分) 30<br/>
                    所需年资(年) 1-5
                </span>
      </div>
    </div>

    <div class="customCard customCardInner" id="customCardInner3">
      <div class="customCardLeft fontSize16">
        <span class="textVerticalCenter">C<br/>级<br/>客<br/>户</span>
      </div>
      <div class="customCardRight fontSize14 lineHeight27">
                <span class="textVerticalCenter">
                    平均单价(万) 100<br/>
                    拜访时间(分) 15<br/>
                    所需年资(年) 不限
                </span>
      </div>
    </div>
  </div>

  <div id="reviewBox">
    <!--<div id="reviewBoxTitle" class="fontSize18 lineHeight24" >-->
    <!--场景回顾-->
    <!--</div>-->
    <p class="excellentDemonstrationTitle flowerBorderBottom">场景回顾</p>

    <div class="reviewItem" *ngFor="let item of eventHistory;let i=index">

      <!--<p><span>王立娜</span><span>老大，客户已经到了，但有个情况我搞不定，想问问该怎么办。</span></p>-->
      <!--<p><span class="fontBlue">我</span><span>出了什么事？</span></p>-->
      <!--<p><span>王立娜</span><span>客户对新产品也很有兴趣，想了解技术方面的细节，但技术方面我不擅长，方科科也不在…</span></p>-->
      <!--<p class="fontBlue2">「最佳选择」</p>-->
      <!--<p>立娜，你还记得研发部的方信愿意支持27号的市场活动么？你可以和他沟通下目前的情况，看是否可以得到他的协助。</p></div>-->
      <!--<div class="sectionBox sectionBox4">-->
      <!--<div class="sectionIcon2">剧情4</div>-->
      <!--<p>参展客户临时有了变动，但因为整个团队都在飞机上，未能及时收到主办方的信息。到了后，我才得知一共只有4小时来拜访客户，那么第一步该怎么做呢？</p>-->
      <!--<p class="fontBlue2">「最佳选择」</p>-->
      <!--<p>想办法取得客户清单和掌握会场情况。</p>-->
      <!--<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>-->
      <!--<p>行动之前，要扎好马步：建立信息基础。只有先收集会场目前最新的状况，才能制定更高效的拜访计划。</p></div>-->
      <!--</div>-->
      <!--<div class="sectionBox sectionBox5">-->
      <!--<div class="sectionIcon2">剧情5</div>-->
      <!--<p>在给其他伙伴安排任务前，先确定自己的任务吧。</p>-->
      <!--<p class="fontBlue2">「最佳选择」</p>-->
      <!--<p>亲自参与拜访客户</p>-->
      <!--<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>-->
      <!--<p>还是回到参加这次展会的目标，要拜访尽可能多的客户，这样才更有利于实现今年我们部门的目标——拓展北美市场。所以这里“我”作为有10年经验的客户经理，是不是也应该与大家并肩作战，参与到拜访客户的行动中呢？</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="sectionBox sectionBox6">-->
      <!--<div class="sectionIcon">剧情6</div>-->
      <!--<p>拜访任务分配</p>-->
      <!--<p class="fontBlue2">「最佳选择」</p>-->
      <!--<p class="smLineHeight"><span>秦飞</span><span>山下A级客户4个</span></p>-->
      <!--<p class="smLineHeight"><span>我</span><span>山下A级客户2个，B级客户1个；山上A级客户1个，C级客户1个</span></p>-->
      <!--<p class="smLineHeight"><span>方科科</span><span>山下B级客户8个</span></p>-->
      <!--<p class="smLineHeight"><span>高朗</span><span>山上C级客户15个</span></p>-->
      <!--<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>-->
      <!--<p>-->
      <!--这里的安排要考虑到4点：第一、每个人年资不一样，“我”和秦飞可以拜访所有类型客户，方科科不能拜访A级客户，高朗只能拜访C级客户。不要越级拜访，或者浪费资源，比如让秦飞去拜访B和C级客户。第二、按照客单价，应该优先安排拜访A级客户，然后才是B级客户，最后再考虑C级客户。第三、要注意时间，每个人只有240分钟，最好都能用上。如果要去山上，还要考虑留15分钟在路上。第四、秦飞身体不适，而“我”和他都可以拜访所有类型客户。最好就是让他在山下，不用爬山劳顿。所以综上所述，建议安排如最佳选择。</p>-->
      <!--</div>-->
      <!--</div>-->
      <div class="reviewDialogInline"  *ngIf="item.type==3">
        <div class="reviewRole fontSize14 lineHeight24 reviewRole_{{item.type}}" *ngIf="item.type==3" [innerHtml]="item.role"></div>
        <div class="reviewComment fontSize14 lineHeight21 reviewComment_{{item.type}}" *ngIf="item.type==3" [innerHtml]="item.comment"> </div>
      </div>


      <div class="bg-lightBlue" *ngIf="item.type==5">
        <div class="excellentDemonstrationTitle reviewRole fontSize14 lineHeight24 reviewRole_{{item.type}}" [innerHtml]="item.role" *ngIf="item.type==5"></div>
        <div class="reviewComment fontSize14 lineHeight21 reviewComment_{{item.type}}" [innerHtml]="item.comment" *ngIf="item.type==1||item.type==2||item.type==5"></div>
      </div>
      <div class="reviewAnswerBox fontSize14 lineHeight24" *ngIf="item.type==4">
        <div class="reviewAnswerHead" [innerHtml]="item.role"></div>
        <div class="reviewAnswerMain reviewAnswerMain_1" [innerHtml]="item.comment"></div>
      </div>
      <div class="reviewAnswerBox fontSize14 lineHeight24" *ngIf="item.type==9" (click)="reviewTableClick($event,i)">
        <div class="reviewAnswerHead">
          {{item.role}}
          <i class="fa fa-caret-up fa-lg discussionBgIcon" *ngIf="item.mode==1"></i>
          <i class="fa fa-caret-down fa-lg discussionBgIcon" *ngIf="item.mode==0"></i>
        </div>
        <div class="reviewAnswerMain reviewAnswerMain_{{item.mode}}" [innerHtml]="item.comment"></div>
      </div>
    </div>
  </div>

  <div id="closeBtn" (click)="closeTip($event)"></div>

  <img src="{{assetsRoute}}/picture/casepracticepando/close.png" alt="" id="customerInfoCloseBtn"
       (click)="onCustomerInfoCloseBtnClick($event)" class="imgAble">
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-event/case-practice-p-and-o-event.component.html